// @ts-check
'use strict';

var _require = require('web-encoding'),
    TextEncoder = _require.TextEncoder,
    TextDecoder = _require.TextDecoder;

var textDecoder = new TextDecoder();
/**
 * @param {ArrayBufferView|ArrayBuffer} bytes
 * @returns {string}
 */

var decodeText = function decodeText(bytes) {
  return textDecoder.decode(bytes);
};

var textEncoder = new TextEncoder();
/**
 * @param {string} text
 * @returns {Uint8Array}
 */

var encodeText = function encodeText(text) {
  return textEncoder.encode(text);
};
/**
 * Returns a new Uint8Array created by concatenating the passed Arrays
 *
 * @param {Array<ArrayLike<Number>>} arrs
 * @param {Number} length
 * @returns {Uint8Array}
 */


function concat(arrs, length) {
  var output = new Uint8Array(length);
  var offset = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = arrs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var arr = _step.value;
      output.set(arr, offset);
      offset += arr.length;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return output;
}

module.exports = {
  decodeText: decodeText,
  encodeText: encodeText,
  concat: concat
};